/**
 * CR118: Theme Labs - Standalone Global Design System Page
 * 
 * Manages global design tokens (typography, colors, spacing, component defaults)
 * that apply across ALL deal cards.
 */

import { AdminLayout } from "@/components/admin/AdminLayout";
import { ThemeLabsTab } from "@/components/admin/command-center/ThemeLabsTab";
import { Palette } from "lucide-react";

export default function ThemeLabs() {
  return (
    <AdminLayout>
      <div className="space-y-6">
        {/* Page Header */}
        <div>
          <h1 className="text-3xl font-bold tracking-tight flex items-center gap-2">
            <Palette className="h-8 w-8 text-primary" />
            Theme Labs
          </h1>
          <p className="text-muted-foreground mt-1">
            Global design tokens for typography, colors, spacing, and component styling
          </p>
        </div>

        {/* Theme Labs Content (reusing existing component) */}
        <ThemeLabsTab />
      </div>
    </AdminLayout>
  );
}
